import { ScoringConfiguration, ScoringConfigurationCreate, ScoringConfigurationUpdate } from '@/models';
import { API_URL, FetchApi } from './service';

const URI = `${API_URL}/core/scoring-configurations/`;

export const ScoringConfigurationServices = {
  /**
   * Récupérer toutes les configurations de scoring avec pagination et filtres
   */
  list: (params?: any) =>
    FetchApi.get(`${URI}?${new URLSearchParams(params).toString()}`),

  /**
   * Créer une nouvelle configuration de scoring
   */
  create: (data: ScoringConfigurationCreate) =>
    FetchApi.post(`${URI}`, data),

  /**
   * Récupérer une configuration de scoring par ID
   */
  get: (id: number) =>
    FetchApi.get(`${URI}${id}/`),

  /**
   * Mettre à jour une configuration de scoring
   */
  update: (id: number, data: ScoringConfigurationUpdate) =>
    FetchApi.put(`${URI}${id}/`, data),

  /**
   * Supprimer une configuration de scoring
   */
  delete: (id: number) =>
    FetchApi.delete(`${URI}${id}/`),

  /**
   * Récupérer la configuration de scoring active
   *
   * GET /scoring-configurations/active/
   */
  getActive: () =>
    FetchApi.get(`${URI}active/`),

  /**
   * Activer une configuration de scoring
   * Cette action désactivera automatiquement toutes les autres configurations
   *
   * POST /scoring-configurations/{id}/activate/
   *
   * @param id - ID de la configuration à activer
   */
  activate: (id: number) =>
    FetchApi.post(`${URI}${id}/activate/`, {}),

  /**
   * Désactiver une configuration de scoring
   *
   * POST /scoring-configurations/{id}/deactivate/
   *
   * @param id - ID de la configuration à désactiver
   */
  deactivate: (id: number) =>
    FetchApi.post(`${URI}${id}/deactivate/`, {}),

  /**
   * Récupérer uniquement les configurations actives
   */
  activeConfigurations: (params?: any) =>
    FetchApi.get(`${URI}?is_active=true&${new URLSearchParams(params).toString()}`),

  /**
   * Récupérer uniquement les configurations inactives
   */
  inactiveConfigurations: (params?: any) =>
    FetchApi.get(`${URI}?is_active=false&${new URLSearchParams(params).toString()}`),
};
